<script>
    import { onMount, onDestroy } from "svelte";
    import {
        loadInitialData,
        connectSSE,
        disconnectSSE,
        mqttConnected,
    } from "../../service/mqtt";
    import { menu, menuSub, menuSubSub } from "../../stores";

    import StatsBar from "./components/StatsBar.svelte";
    import DeviceList from "./components/DeviceList.svelte";
    import DeviceDetail from "./components/DeviceDetail.svelte";

    let selectedDeviceId = "";

    onMount(() => {
        console.log("MqttMonitor: Mounting...");

        // Update breadcrumb manually to ensure correct display
        menu.set("모니터링");
        menuSub.set("MQTT 모니터링");
        menuSubSub.set("");

        loadInitialData();
        connectSSE();
    });

    onDestroy(() => {
        console.log("MqttMonitor: Destroying...");
        disconnectSSE();
    });

    function handleDeviceSelect(event) {
        selectedDeviceId = event.detail;
    }
</script>

<div class="container-xxl flex-grow-1 container-p-y">
    <!-- Stats Bar -->
    <StatsBar />

    <div
        class="row pt-2"
        style="height: calc(100vh - 250px); min-height: 600px;"
    >
        <!-- Left: Device List -->
        <div class="col-md-4 h-100 mb-4">
            <DeviceList {selectedDeviceId} on:select={handleDeviceSelect} />
        </div>

        <!-- Right: Device Detail -->
        <div class="col-md-8 h-100 mb-4">
            <DeviceDetail deviceId={selectedDeviceId} />
        </div>
    </div>
</div>
